import React, { ReactElement } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import CompanyPage
  from '@fuww/library/src/Layouts/CompanyPage';
import Headline3 from '@fuww/library/src/Typography/Heading/Headline3';
import Body1 from '@fuww/library/src/Typography/Body/Body1';
import Headline6 from '@fuww/library/src/Typography/Heading/Headline6';
import Button from '@fuww/library/src/Button';
import TextWithImage from '../components/TextWithImage';
import messages from '../lib/messages.mjs';
import Head from '../components/Head';
import Hero from '../components/Hero';
import { textWithImageConfigurations }
  from '../lib/imageConfigurations';
import getSourceSet from '../lib/getSourceSet';
import Layout from '../components/Layout';
import createCompanyBreadcrumbs from '../lib/createCompanyBreadcrumbs';
import LinkAndAnchor from '../components/LinkAndAnchor';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/9MwSHoYZHkXms1cUTUAP1tgcAzVstC2uR5W0hO5Mut8/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9kaXNwbGF5X2FkdmVydGlzaW5nX2hlYWRlcl9tb2JpbGUuanBn',
    'https://r.fashionunited.com/iOBVK3z5l3zNFeYmkSorhnPaI5Df93AGgQ7wEjj-BU8/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9kaXNwbGF5X2FkdmVydGlzaW5nX2hlYWRlcl9tb2JpbGUuanBn',
    'https://r.fashionunited.com/VIznN4p0pAoGvVDiYvG8Da8pwKIpeQtWNdWn7CdsT88/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9kaXNwbGF5X2FkdmVydGlzaW5nX2hlYWRlcl9tb2JpbGUuanBn',
  ],
  desktop: [
    'https://r.fashionunited.com/ULCsr5g_ik0w9XMADl4A0Muw1N0ouLIgjdDplUZ9wTY/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9kaXNwbGF5X2FkdmVydGlzaW5nX2hlYWRlci5qcGc',
    'https://r.fashionunited.com/KnGTP8HvnbMsYI2gl3mDoo6A_LVeXu7LVHubm8dx-H4/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9kaXNwbGF5X2FkdmVydGlzaW5nX2hlYWRlci5qcGc',
    'https://r.fashionunited.com/VP3y6FyHCa0EV_3IPJP2Xw14vzlFh89N--0qoL59bFM/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9kaXNwbGF5X2FkdmVydGlzaW5nX2hlYWRlci5qcGc',
    'https://r.fashionunited.com/nupc2oSatxzml3PubowjIBwt-smD8eMkKzko2Rtevyg/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9kaXNwbGF5X2FkdmVydGlzaW5nX2hlYWRlci5qcGc',
  ],
};

const imageUrls = {
  banners: [
    'https://r.fashionunited.com/bHblAjusn4__zzpVOqXtAmITh4Fq9_QYqr43P-GTDo0/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy90YWlsb3JlZF9iYW5uZXJfc29sdXRpb25zLmpwZw',
    'https://r.fashionunited.com/qXajIbTDlHrEyedaWUhw5lMpmFtlPkprnNbH-AhkIY4/resize:fill:360:240:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy90YWlsb3JlZF9iYW5uZXJfc29sdXRpb25zLmpwZw',
    'https://r.fashionunited.com/Hvjn-cI8emHAAYyU0SRdEjb6ZEvxOY8prUiQqBz7SdM/resize:fill:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy90YWlsb3JlZF9iYW5uZXJfc29sdXRpb25zLmpwZw',
    'https://r.fashionunited.com/qJicH8lQVhZm3TVgwRfaKdQ-WS1bQEX4HCfGQ-DuY50/resize:fill:920:613:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy90YWlsb3JlZF9iYW5uZXJfc29sdXRpb25zLmpwZw',
  ],
  newsletters: [
    'https://r.fashionunited.com/a5DtPy8aRs15tnyGtuSpiISKijznDYxnPGo2W9KLWSQ/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbmV3c2xldHRlci1pbnRlZ3JhdGlvbi5wbmc',
    'https://r.fashionunited.com/13jXW-MtWcV9XIukQKsl8KAV67U1FhZQsTD7-3HMgKA/resize:fill:360:240:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbmV3c2xldHRlci1pbnRlZ3JhdGlvbi5wbmc',
    'https://r.fashionunited.com/bewOlLF06jFM6ZWihc3nqJERhUGdmP95rHnzhu-UY2Q/resize:fill:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbmV3c2xldHRlci1pbnRlZ3JhdGlvbi5wbmc',
    'https://r.fashionunited.com/3SPQOG3XG_cyAQTiNJpbt8MuTzs9KzUdMjjRQL0sRYE/resize:fill:920:613:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbmV3c2xldHRlci1pbnRlZ3JhdGlvbi5wbmc',
  ],
};

interface ContentSectionProperties {
  headlineKey: string;
  bodyKey: string;
  intl: IntlShape;
}

const ContentSection = ({
  headlineKey,
  bodyKey,
  intl,
}: ContentSectionProperties) => (
  <>
    <Headline6 color="primary">
      {intl.formatMessage(messages[headlineKey])}
    </Headline6>
    <Body1>
      {intl.formatMessage(messages[bodyKey])}
    </Body1>
    <br />
  </>
);

const DisplayAdvertisingPage = () => {
  const intl = useIntl();

  const breadcrumbs = createCompanyBreadcrumbs({
    intl,
    crumbRoute: 'display-advertising',
    crumbLabel: intl.formatMessage(messages['displayAdvertising.header']),
  });

  return (
    <>
      <Head
        title={intl.formatMessage(messages['displayAdvertising.header'])}
        description=""
      />
      <CompanyPage
        breadcrumbs={breadcrumbs}
        description={intl.formatMessage(
          messages['displayAdvertising.description'],
        )}
        textWithImageComponents={(
          <>
            <TextWithImage
              buttonLabel={intl.formatMessage(messages[
                'employerBranding.buttonLabel'
              ])}
              buttonHref="mailto:media@fashionunited.com"
              description={(
                <div
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: intl.formatMessage(
                      messages['displayAdvertising.bannersBody'],
                    ),
                  }}
                />
              )}
              imagePosition="right"
              imageUrls={imageUrls.banners}
              srcSet={getSourceSet(
                textWithImageConfigurations, imageUrls.banners,
              )}
              title={intl.formatMessage(
                messages['displayAdvertising.bannersHeader'],
              )}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(messages[
                'employerBranding.buttonLabel'
              ])}
              buttonHref="mailto:media@fashionunited.com"
              description={intl.formatMessage(
                messages['displayAdvertising.jobBoardBannerBody'],
              )}
              imagePosition="left"
              imageUrls={imageUrls.newsletters}
              srcSet={getSourceSet(
                textWithImageConfigurations, imageUrls.newsletters,
              )}
              title={intl.formatMessage(
                messages['displayAdvertising.jobBoardBannerHeader'],
              )}
            />
          </>
        )}
        title={intl.formatMessage(messages['displayAdvertising.header'])}
      >
        <>
          <Headline3 align="center">
            {intl.formatMessage(messages['displayAdvertising.subHeader'])}
          </Headline3>
          <br />
          <ContentSection
            headlineKey="displayAdvertising.visibilityHeader"
            bodyKey="displayAdvertising.visibilityBody"
            intl={intl}
          />
          <ContentSection
            headlineKey="displayAdvertising.targetedReachHeader"
            bodyKey="displayAdvertising.targetedReachBody"
            intl={intl}
          />
          <ContentSection
            headlineKey="displayAdvertising.versatilityHeader"
            bodyKey="displayAdvertising.versatilityBody"
            intl={intl}
          />
          <ContentSection
            headlineKey="displayAdvertising.newsletterAmplificationHeader"
            bodyKey="displayAdvertising.newsletterAmplificationBody"
            intl={intl}
          />
          <br />
          <Body1>
            {intl.formatMessage(messages['displayAdvertising.contactUs'])}
          </Body1>
          <br />
        </>
        <br />
        <LinkAndAnchor
          href="mailto:media@fashionunited.com"
          passHref
        >
          <Button variant="contained">
            {intl.formatMessage(messages[
              'employerBranding.buttonLabel'
            ])}
          </Button>
        </LinkAndAnchor>
      </CompanyPage>
    </>
  );
};

DisplayAdvertisingPage.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        alt="Display Advertising banner image"
        imageUrls={headerImageUrls}
      />
    )}
  >
    {page}
  </Layout>
);

export default DisplayAdvertisingPage;
